var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.encendido)?_c('div',{staticClass:"turnstile-widget",attrs:{"data-test":"turnstile"}},[_c('div',{ref:"caja",staticClass:"turnstile-widget__caja"}),(_vm.fallo)?_c('p',{staticClass:"turnstile-widget__fallo",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.$t('turnstile.failed')))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }